"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AdminPermissions () {
        return AdminPermissions;
    },
    get ReportingReviewReportDocument () {
        return ReportingReviewReportDocument;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _user = require("../user");
const AdminPermissions = _zod.z.object({
    "group-feedback": _zod.z.boolean(),
    "group-reviews": _zod.z.boolean(),
    "group-goals": _zod.z.boolean()
});
const ReportingReviewReportDocument = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    review: _zod.z.object({
        id: _zod.z.instanceof(_bson.ObjectId),
        name: _zod.z.string(),
        start_date: _zod.z.date(),
        completed: _zod.z.boolean(),
        subject: _zod.z.object({
            _id: _zod.z.instanceof(_bson.ObjectId),
            name: _zod.z.string(),
            email: _zod.z.object({
                original: _zod.z.string(),
                normalized: _zod.z.string()
            }),
            company: _zod.z.object({
                _id: _zod.z.instanceof(_bson.ObjectId),
                name: _zod.z.string()
            }),
            manager: _zod.z.object({
                _id: _zod.z.instanceof(_bson.ObjectId),
                email: _zod.z.string(),
                name: _zod.z.string(),
                deactivated: _zod.z.object({
                    at: _zod.z.date().nullable(),
                    user: _zod.z.instanceof(_bson.ObjectId).nullable()
                }).nullable()
            }).nullable(),
            chain_of_command: _zod.z.array(_user.SkinnyEmployee).nullable(),
            group: _zod.z.object({
                _id: _zod.z.instanceof(_bson.ObjectId),
                company_id: _zod.z.instanceof(_bson.ObjectId),
                name: _zod.z.string(),
                admins: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
                employees: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
                admin_permissions: AdminPermissions.nullable()
            }).nullable(),
            group_administrator: _zod.z.object({
                _id: _zod.z.instanceof(_bson.ObjectId),
                admins: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
                employees: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
                company: _zod.z.instanceof(_bson.ObjectId),
                name: _zod.z.string(),
                admin_permissions: AdminPermissions.nullable()
            }).nullable(),
            custom_values: _zod.z.record(_zod.z.string(), _zod.z.unknown()).nullable(),
            primary_role: _zod.z.string().nullable(),
            deactivated: _zod.z.object({
                state: _zod.z.boolean(),
                at: _zod.z.date().nullable(),
                by: _zod.z.instanceof(_bson.ObjectId).nullable()
            }).nullable()
        }),
        participants: _zod.z.array(_user.SkinnyEmployee),
        completed_date: _zod.z.date().nullable(),
        easy_add_enabled: _zod.z.boolean(),
        forms_awaiting_approval: _zod.z.array(_zod.z.unknown()),
        status: _zod.z.string()
    }),
    authors_due_date: _zod.z.date().nullable(),
    signers_due_date: _zod.z.date().nullable(),
    authors: _zod.z.array(_user.SkinnyEmployee),
    signers: _zod.z.array(_user.SkinnyEmployee),
    participants: _zod.z.array(_user.SkinnyEmployee),
    questions: _zod.z.array(_zod.z.object({
        type: _zod.z.string(),
        question: _zod.z.string(),
        subtext: _zod.z.string().nullable(),
        hash: _zod.z.string(),
        _id: _zod.z.instanceof(_bson.ObjectId),
        answer: _zod.z.unknown().nullable(),
        form_name: _zod.z.string(),
        form_id: _zod.z.instanceof(_bson.ObjectId)
    })),
    question_hashes: _zod.z.array(_zod.z.string()),
    visible_to_subject: _zod.z.boolean(),
    redact_authors: _zod.z.boolean(),
    review_template: _zod.z.object({
        id: _zod.z.instanceof(_bson.ObjectId).nullable(),
        name: _zod.z.string().nullable(),
        questions: _zod.z.array(_zod.z.object({
            type: _zod.z.string(),
            question: _zod.z.string(),
            subtext: _zod.z.string().nullable(),
            hash: _zod.z.string()
        })).optional()
    }),
    review_cycle: _zod.z.object({
        id: _zod.z.instanceof(_bson.ObjectId),
        name: _zod.z.string(),
        is_360_enabled: _zod.z.boolean(),
        _id: _zod.z.instanceof(_bson.ObjectId),
        company_id: _zod.z.instanceof(_bson.ObjectId),
        start_date: _zod.z.date(),
        complete_date: _zod.z.date().nullable(),
        template: _zod.z.object({
            id: _zod.z.instanceof(_bson.ObjectId),
            name: _zod.z.string()
        }),
        status: _zod.z.string()
    }).nullable(),
    form_360: _zod.z.object({
        configuration_id: _zod.z.instanceof(_bson.ObjectId),
        requires_approval: _zod.z.boolean()
    }).nullable(),
    status: _zod.z.enum([
        "in-progress-awaiting-signoff",
        "in-progress-awaiting-authors",
        "completed",
        "deleted"
    ]),
    review_form: _zod.z.object({
        id: _zod.z.instanceof(_bson.ObjectId),
        name: _zod.z.string()
    }),
    question_map: _zod.z.record(_zod.z.string(), _zod.z.object({
        _id: _zod.z.instanceof(_bson.ObjectId),
        answer: _zod.z.unknown(),
        question: _zod.z.string(),
        type: _zod.z.string(),
        hash: _zod.z.string(),
        form_name: _zod.z.string(),
        form_id: _zod.z.instanceof(_bson.ObjectId),
        subtext: _zod.z.string().nullable()
    })),
    completed_date: _zod.z.date().nullable(),
    author_turn: _zod.z.number(),
    signer_turn: _zod.z.number(),
    authoring_completed_at: _zod.z.date().nullable(),
    signing_completed_at: _zod.z.date().nullable(),
    last_update: _zod.z.date().nullish()
});
